// extracted by mini-css-extract-plugin
module.exports = {"stories":"_1jY-N","more-wrapper":"_8-Qic"};